<div class="flex justify-center mt-3.5 pb-6">
  <lib-app-icon class="logo-icon" [icon]="'nagel_logo'" [size]="collapsed ? '48x48' : '68x68'"></lib-app-icon>
</div>
@if (!collapsed) {
  <h2 class="px-[92px] mat-headline-6" i18n>{{title}}</h2>
}
